"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _constants = require("../utils/constants");

var _FormValidationOverlay = _interopRequireDefault(require("./_FormValidationOverlay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _textarea = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/textarea.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _textarea.default);
/** A **FormTextarea** is used to gather potentially lengthy input from a user.
 * Best practice is to use this component as a child of FormGroup. */

var FormTextarea = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var className = _ref.className,
      compact = _ref.compact,
      counterProps = _ref.counterProps,
      cssNamespace = _ref.cssNamespace,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      localizedText = _ref.localizedText,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      value = _ref.value,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "compact", "counterProps", "cssNamespace", "defaultValue", "disabled", "localizedText", "maxLength", "onChange", "readOnly", "validationOverlayProps", "validationState", "value"]);

  var getInitialCharCount = function getInitialCharCount() {
    if (typeof value === 'boolean' || value) {
      return Math.min(value.toString().length, maxLength);
    }

    if (defaultValue) {
      return Math.min(defaultValue.toString().length, maxLength);
    }

    return 0;
  };

  var hasMaxLength = maxLength >= 0;

  var _useState = (0, _react.useState)(hasMaxLength ? getInitialCharCount() : 0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      charCount = _useState2[0],
      setCharCount = _useState2[1];

  var getMaxLengthText = function getMaxLengthText() {
    var _context2;

    var charactersLeftPlural = localizedText.charactersLeftPlural,
        charactersLeftSingular = localizedText.charactersLeftSingular;
    var charsLeft = Math.max(maxLength - charCount, 0);

    if (charsLeft !== 1) {
      var _context;

      return (0, _concat.default)(_context = "".concat(charsLeft, " ")).call(_context, charactersLeftPlural);
    }

    return (0, _concat.default)(_context2 = "".concat(charsLeft, " ")).call(_context2, charactersLeftSingular);
  };

  var handleOnChange = function handleOnChange(e) {
    if (hasMaxLength) setCharCount(e.target.value.length);
    if (onChange) onChange(e);
  };

  var formTextAreaClasses = classnames("".concat(cssNamespace, "-textarea"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-textarea--compact"), compact), (0, _defineProperty2.default)(_classnames, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), _classnames), className);
  var counterClasses = classnames("".concat(cssNamespace, "-textarea-counter"), counterProps === null || counterProps === void 0 ? void 0 : counterProps.className);

  var formTextarea = /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({}, props, {
    className: formTextAreaClasses,
    defaultValue: defaultValue,
    disabled: disabled,
    maxLength: maxLength,
    onChange: handleOnChange,
    readOnly: readOnly,
    ref: ref,
    value: value
  }));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, validationState !== null && validationState !== void 0 && validationState.state ? /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
    control: formTextarea,
    validationState: validationState
  })) : formTextarea, hasMaxLength && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, counterProps, {
    className: counterClasses
  }), getMaxLengthText()));
});

FormTextarea.displayName = 'FormTextarea';
process.env.NODE_ENV !== "production" ? FormTextarea.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Props to pass to the counter div */
  counterProps: _propTypes.default.object,

  /** Default placeholder value for the textarea */
  defaultValue: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    charactersLeftPlural: _propTypes.default.string,
    charactersLeftSingular: _propTypes.default.string
  }),

  /** Set the max length of the textarea */
  maxLength: _propTypes.default.number,

  /** Set to **true** to mark component as readonly */
  readOnly: _propTypes.default.bool,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Value for the textarea */
  value: _propTypes.default.string,

  /** Callback function when the change event fires on the component */

  /**
   * Callback function; triggered when the change event fires on the HTML `<textarea>`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onChange: _propTypes.default.func
} : void 0;
FormTextarea.defaultProps = {
  localizedText: {
    charactersLeftPlural: 'characters left',
    charactersLeftSingular: 'character left'
  }
};

var _default = (0, _withStyles.default)(FormTextarea);

exports.default = _default;